export const formatNumber = (n) => {
    const num = Number(n);
    if (!Number.isFinite(num)) return "0";
    return num.toLocaleString();
};

export const formatK = (n) => {
    const num = Number(n) || 0;
    if (Math.abs(num) >= 1_000_000) return `${(num / 1_000_000).toFixed(1)}M`;
    if (Math.abs(num) >= 1_000) return `${(num / 1_000).toFixed(1)}k`;
    return String(Math.round(num));
};

export const niceCeil = (n) => {
    const num = Number(n) || 0;
    if (num <= 0) return 5;
    const padded = num * 1.1;
    const magnitude = 10 ** Math.floor(Math.log10(padded));
    return Math.ceil(padded / magnitude) * magnitude;
};

export const toneClass = (tone) => {
    switch (tone) {
        case "success":
            return "bg-success-main";
        case "warning":
            return "bg-warning-main";
        case "danger":
            return "bg-danger-main";
        default:
            return "bg-info";
    }
};

export const activityIcon = (type, tone) => {
    const t = String(type || "").toLowerCase();
    if (t.includes("campaign")) return "mdi:bullhorn";
    if (t.includes("template")) return "mdi:file-document-outline";
    if (t.includes("queue")) return "mdi:timer-sand";
    if (t.includes("instance")) return "logos:whatsapp-icon";
    if (t.includes("contact")) return "mdi:account-multiple-outline";
    if (tone === "danger") return "mdi:alert-circle-outline";
    if (tone === "warning") return "mdi:alert-outline";
    if (tone === "success") return "mdi:check-circle-outline";
    return "mdi:bell-outline";
};
